//# sourceMappingURL=maps/scripts.js.map

(function($) {
    Drupal.behaviors.mytimeactiveBehavior = {
      attach: function (context, settings) {
        if ($('[data-opening-hours-tabs]').length) {
          var tabs = new Tabby('[data-opening-hours-tabs]');
        }

        if (window.matchMedia("(min-width: 768px)").matches) {
          $('#block-mainnavigation-2 > .menu > li.menu-item').on({
            mouseenter: function() {
              $(this).attr("aria-expanded","true");
            },
            mouseleave: function() {
              $(this).attr("aria-expanded","false");
            }
          })
        }

        //Search toggle
        $(".search-toggle").once('search-clicked').click(function(){
          $(".block-views-exposed-filter-blocksearch-page-1").toggleClass("open");
          $("#block-mainnavigation-2").toggleClass("search-active");
          $('.form-item-search-api-fulltext input').focus();
        });

        // Header animation
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
          if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
            document.getElementById("site-header").style.height = "64px";
            $('.menu--main > .menu').addClass('slim');
          } else {
            document.getElementById("site-header").style.height = "80px";
            $('.menu--main > .menu').removeClass('slim');
          }
        }

        /**
         *  (Carousel)
         */
        $('.paragraph--type--homepage-carousel-item > .field__items').flickity({
          draggable: false,
          cellAlign: 'left',
          prevNextButtons: true,
          pageDots: false,
          contain: true,
          freeScroll: true,
          groupCells: true
        });

        //Inputs and selects
        $('select').select2({
          allowClear: false
        });

        $("#edit-field-facility-type-target-id").select2({
          placeholder: "All facility types"
        });

        $(".paragraph--type--customer-notice .field--name-field-title").click(function() {
          $(this).toggleClass("active");
        });

        // Navigate to activity detail page when user selects an activity filter.
        $('.view-activities #edit-nid').select2({
          placeholder: "Type an activity or class"
        }).on('select2:select', function(e) {
          window.open('/node/' + e.params.data.id, '_self');
        });

        // Deselecting Activity filter when the user navigates back and selects any filter.
        $('.view-activities #edit-field-activity-types-target-id').select2({
        }).on('select2:select', function(e) {
          // Deselecting activity filter.
          $('.view-activities #edit-nid').val('').change();
        });
        // Deselecting Activity filter when the user navigates back and selects any filter.
        $('.view-activities #edit-field-locations-target-id').select2({
        }).on('select2:select', function(e) {
          // Deselecting activity filter.
          $('.view-activities #edit-nid').val('').change();
        });

        // Deselecting Activity filter when the user navigates back and clicks apply filters button.
        $('.view-activities #edit-submit-activities').click(function() {
            // Deselecting activity filter.
            $('.view-activities #edit-nid').val('').change();
        });
      }
    };

    if (document.querySelector(".embed-container")) {
      var iframeElem = document.querySelector(".embed-container");
      var iframesrc = document.querySelectorAll(".embed-container iframe")[0].src
      var newIframe = document.createElement('iframe');
      var newIframeWidth = document.querySelector(".paragraph--type--timetable").offsetWidth;

      iframeElem.parentNode.removeChild(iframeElem);
      newIframe.src = iframesrc + '&amp;width=' + newIframeWidth;
      document.querySelector(".paragraph--type--timetable").appendChild(newIframe);
    }

  })(jQuery);
